/* FD brand ---------------------------------------------------------------
   Furniture Done collection pages: the two measurements the sticky bars need.

   The filter toolbar and the sets page's chip bar both stick under the site
   header, and the header changes height when it compacts on scroll. A constant
   offset would therefore be wrong in one state or the other, so the live
   height is measured and published as --fd-stick-top. --fd-chip-h does the
   same job for the chip bar, which the grouped sections' scroll-margin has to
   clear as well; it reports 0 whenever the bar is not actually sticking, so a
   phone (where both bars return to the flow) gets no phantom offset.

   Nothing here is a behaviour: filtering, sorting and the disclosure panels are
   all Dawn's own facets.js. This file only measures.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var root = document.documentElement;

  function isSticking(el) {
    return el ? getComputedStyle(el).position === 'sticky' : false;
  }

  function measure() {
    var header = document.querySelector('.fd-hdr-wrap--sticky');
    var top = isSticking(header) ? Math.ceil(header.getBoundingClientRect().height) : 0;
    root.style.setProperty('--fd-stick-top', top + 'px');

    var chipbar = document.querySelector('.fd-chipbar');
    var chipHeight = isSticking(chipbar) ? Math.ceil(chipbar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--fd-chip-h', chipHeight + 'px');
  }

  measure();

  /* Three sections load this file (fd-collection-grid, fd-collection-groups,
     fd-fabric-swatch-grid), and the theme editor re-injects a section's <script>
     when it re-renders that section -- so this IIFE can run several times on one
     page. Everything it measures is page-level, so repeat runs must NOT stack a
     second resize listener and a second ResizeObserver on top of the first: the
     one live registration is published on window, and a repeat run only
     re-measures. (Nothing is unbound on section unload: the listener belongs to
     the page, not to any one section, and another section on the page may still
     depend on the offsets it writes.) */
  if (window.fdCollectionMeasure) {
    window.fdCollectionMeasure();
    return;
  }
  window.fdCollectionMeasure = measure;
  window.addEventListener('resize', measure, { passive: true });

  /* The header compacts on scroll, which changes its height without a resize
     event, so the bar is re-measured whenever the header box changes. The
     header is a section too, so the observer is re-pointed at whatever node the
     editor left behind rather than holding the detached original. */
  var headerObserver = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;

  function observeHeader() {
    if (!headerObserver) return;
    var header = document.querySelector('.fd-hdr-wrap--sticky');
    headerObserver.disconnect();
    if (header) headerObserver.observe(header);
  }

  observeHeader();

  document.addEventListener('shopify:section:load', function () {
    observeHeader();
    measure();
  });

  /* A section leaving can take the chip bar with it, which changes the offsets. */
  document.addEventListener('shopify:section:unload', function () {
    observeHeader();
    measure();
  });
})();
